import { render } from "./DistStat.vue?vue&type=template&id=745bd517&scoped=true"
import script from "./DistStat.vue?vue&type=script&lang=js"
export * from "./DistStat.vue?vue&type=script&lang=js"

import "./DistStat.vue?vue&type=style&index=0&id=745bd517&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745bd517"]])

export default __exports__